export default {
  state: {
    globalAdConfirmRoute: {},
    globalAdCancelRoute: {},
    globalAdPeriod: {},
    globalAdShow: false,
  },
  mutations: {
    setGlobalAdConfirm: (state, route) => {
      state.globalAdConfirmRoute = route
    },
    setGlobalAdCancel: (state, route) => {
      state.globalAdCancelRoute = route
    },
    setGlobalAdPeriod: (state, globalAdPeriod) => {
      state.globalAdPeriod = globalAdPeriod
    },
    setGlobalAdShow: (state, tof) => {
      state.globalAdShow = !!tof;
      console.log(state.globalAdShow);
    }
  },
  getters: {
    GlobalAdConfirmRoute: state => state.globalAdConfirmRoute,
    GlobalAdCancelRoute: state => state.globalAdCancelRoute,
    GlobalAdPeriod: state => state.globalAdPeriod,
    GlobalAdShow: state => state.globalAdShow,
  },
  actions: {},
}



// WEBPACK FOOTER //
// ./src/store/modules/ad.js